import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import React from 'react';
/**
 * Class that manages an "aria-live" element to announce page changes and other
 * events for the benefit of screen readers.
 *
 * Make sure to add `AnnounceElement` to the page in _document so that
 * screen readers can see it.
 */

var ScreenReaderSupport =
/*#__PURE__*/
function () {
  function ScreenReaderSupport() {
    _classCallCheck(this, ScreenReaderSupport);

    this.el = null;
  }

  _createClass(ScreenReaderSupport, [{
    key: "announce",
    value: function announce(message) {
      var interrupt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.el) {
        this.el.innerText = message;
        this.el.setAttribute('aria-live', interrupt ? 'assertive' : 'polite');
      }
    }
  }, {
    key: "attach",
    value: function attach() {
      this.el = document.getElementById(ScreenReaderSupport.ANNOUNCE_ID);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.el = null;
    }
  }], [{
    key: "AnnounceElement",
    value: function AnnounceElement() {
      return React.createElement("div", {
        className: "a11y--h",
        "aria-live": "polite",
        id: ScreenReaderSupport.ANNOUNCE_ID
      });
    }
  }]);

  return ScreenReaderSupport;
}();

ScreenReaderSupport.ANNOUNCE_ID = 'ScreenReaderSupport-announce';
export { ScreenReaderSupport as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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